export default "__VITE_ASSET__3BsbE5d6__"